import { MonthYear } from "@common/types";

export class MonthPickerDialogViewModel
{
    id: string | null = null;

    title: string = "Set date";
    description: string | null = null;
    defaultDate: MonthYear | null = null;
    valueRequired: boolean = false;

    isOpened: boolean = false;

    show(defaultDate: MonthYear | null, title: string, valueRequired: boolean = false)
    {
        this.defaultDate = defaultDate;
        this.title = title;
        this.valueRequired = valueRequired;

        this.isOpened = true;
    }

    close()
    {
        this.isOpened = false;

        this.defaultDate = null;
        this.title = "Set date";
        this.description = null;
        this.valueRequired = false;
    }
}


export class MonthPickerDate
{
    from?: Date | null = null;
    to?: Date | null = null;
    month?: string | null = null;
    year: number | null = null;
    monthIndex: number | null = null; //1-12
    //rangeFrom: number | null = null;
    //rangeTo: number | null = null;
    //rangeFromMonth: number | null = null;
    //rangeToMonth: number | null = null;

    static isValid(date: MonthPickerDate | null, minDate: Date | null, maxDate: Date | null): boolean
    {
        if (!date || !date.year || !date.monthIndex)
        {
            return false; // Date is incomplete or null
        }

        // Convert MonthPickerDate to a JavaScript Date object
        const validatedDate = new Date(date.year, date.monthIndex - 1, 1); // 1st day of the month

        if (minDate && validatedDate < minDate)
        {
            return false; // Date is earlier than the minimum
        }
        if (maxDate && validatedDate > maxDate)
        {
            return false; // Date is later than the maximum
        }

        return true; // Date is valid
    }
}

